import { useCallback, useEffect, useRef } from "react";
import { CaseData, UserAccount } from "../data/types";
import SignalRServiceManager from "./SignalRServiceManager";

type CaseDataSignalRProps = {
    primaryAccount?: UserAccount;
    onUpsertCaseData?: (caseData: CaseData) => void;
}
export const useCaseDataSignalR = (props: CaseDataSignalRProps) => {
    const { primaryAccount, onUpsertCaseData } = props;
    const messageName = "upsertCaseData";

    // Use useRef to maintain stable reference
    const onUpsertCaseDataRef = useRef(onUpsertCaseData);

    useEffect(() => {
        onUpsertCaseDataRef.current = onUpsertCaseData;
    }, [onUpsertCaseData]);

    const upsertHandler = useCallback((caseDataJson: string) => {
        try {
            const caseData = JSON.parse(caseDataJson);
            onUpsertCaseDataRef.current?.(caseData);
        } catch (error) {
            console.error("Failed to parse signalR message:", error, caseDataJson);
        }
    }, []); // Now stable

    useEffect(() => {
        let signalRManager: Awaited<ReturnType<typeof SignalRServiceManager.getInstance>> | null = null;

        const setupSignalR = async () => {
            if (primaryAccount) {
                signalRManager = await SignalRServiceManager.getInstance(primaryAccount);
                signalRManager?.on(messageName, upsertHandler);
            }
        };

        setupSignalR();

        return () => {
            signalRManager?.off(messageName, upsertHandler);
        };
    }, [primaryAccount, upsertHandler]);

    return null;
}